import React from "react";
import Select from "react-select";
import { colors } from "../../css components/Style";

export default function SortBy({ sortBy, setSortBy, setPage }) {
  let sortList = [
    { value: "", label: "ALL", color: colors.blue },
    { value: 1, label: "Verified", color: colors.green },
    { value: 0, label: "Unverified", color: colors.yellow },
    { value: 2, label: "Rejected", color: colors.error },
  ];

  const style = {
    control: (base) => ({
      ...base,
      border: 0,
      height: "50px",
      p: "15px 18px",
      color: "#000000",
      fontWeight: 400,
      display: "flex",
      width: "150px",
      fontsize: "14px",
      lineHeight: "20px",
      alignItems: "center",
      borderRadius: "30px",
      justifyContent: "space-between",
      boxShadow: "rgba(0, 0, 0, 0.05) 0px 0px 0px 1px",
    }),
    dropdownIndicator: (base) => ({
      ...base,
      color: " #000000",
    }),
    singleValue: (styles, { data }) => ({
      ...styles,
      fontWeight: 600,
      color: data.color,
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        color: data.color,
        fontWeight: isSelected ? 600 : 400,
        backgroundColor: "white",
        fontSize: "18px",
        lineHeight: "20px",
        mixBlendMode: "normal",
        cursor: isDisabled ? "not-allowed" : "default",
      };
    },
  };

  const handleTypeSelect = (e) => {
    setPage(1);

    setSortBy(e.value);
  };

  return (
    <Select
      styles={style}
      options={sortList}
      onChange={handleTypeSelect}
      isSearchable={false}
      components={{
        IndicatorSeparator: () => null,
      }}
      value={sortList.filter(function (option) {
        return option.value === sortBy;
      })}
    />
  );
}
